<template>
  <div class="text-center">
    <a
      :href="'/products/' + product.handle"
      class="block mb-2"
    >
      <img-yay
        ref="img"
        :src="imageSrc"
        :width="458"
        :height="330"
        :lazy="false"
        sizes="(min-width: 640px) 458px, 98vw"
        alt="Product image"
        class="object-fit min w-full md:w-auto mb-4"
        @mouseover="showSneakPeak = true"
        @mouseleave="showSneakPeak = false"
      />
      <div class="mb-4">
        <h3 class="font-medium leading-6 tracking-wide -mt-4">
          <template v-if="splitTitle(product).length > 0">
            <span class="inline-block">{{ splitTitle(product)[0] }}</span>
            <span class="inline-block ml-1">{{ splitTitle(product)[1] }}</span>
          </template>
          <template v-else>
            {{ product.title }}
          </template>
        </h3>
        <div class="font-title mt-2">{{ strings.product.price.currency_symbol }}{{ formatPrice(product.price) }}</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: { product: { type: Object, required: true } },
  data: function () {
    let variant = this.product.variants[0];
    let images = []
    let showSneakPeak = false
    let strings
    images[variant.title] = this.variantImageSrc(variant);
    strings = window.themeVariables.i18n;
    return { variant, images, showSneakPeak, strings };
  },
  computed: {
    imageSrc: function () {
      if (this.showSneakPeak && this.sneakPeak) {
        return this.sneakPeak
      }
      return this.images[this.variant.title]
    },
    sneakPeak: function() {
      // We watch this property for changes and then preload the image
      return this.product.sneakPeak
    }
  },
  watch: {
    sneakPeak() {
      this.preloadImages([this.sneakPeak], true)
    }
  },
  created() {
    this.preloadImages(this.images)
  },
  methods: {
    variantImageSrc(variant) {
      let result = variant.image; // From Boost API
      if (variant.featured_image) {
        // From Shopify Template
        result = variant.featured_image.src;
      }
      // If no variant image is found, just use the default product image
      if (!result) {
        result = this.product.featured_image;
      }
      return result
    },

    splitTitle(product) {
      const i = product.title.indexOf(': ')
      let result = []
      if (i > -1) {
        result = [product.title.slice(0, i+1), product.title.slice(i+1)]
      }
      return result
    },

    preloadImages(images, high_priority = false) {
      // Size factors taken from img-yay component (1, 1.5 & 2)
      if( screen.width > 480 ) { // Don't preload on mobile
        let result = [];
        ["458x330", "687x495", "916x660"].forEach(size => {
          result = result.concat(Object.values(images).map(src => {
            return src ? this.formatImageSize(src, `_${size}_crop_center`) : null;
          }))
        })
        this.$store.commit('config/preloadImages', { images: result, high_priority })
      }
    }
  }
};
</script>
